import { makeStyles } from '@material-ui/core';
import { getFillColor, LogoProps } from './common';

export const LogoFull = ({
  fullWidth = false,
  applyTheme = false,
  width,
  height,
  maxWidth,
  fillColor,
}: LogoProps) => {
  const classes = makeStyles(theme => ({
    svg: {
      width: width || '163',
      maxWidth: maxWidth || 'auto',
      height: height || fullWidth ? 'auto' : 26,
    },
    path: {
      fill: fillColor ? fillColor : getFillColor(theme, applyTheme),
    },
  }))();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 163 26"
    >
      <path
        className={classes.path}
        d="M122.811 25.055C115.897 25.055 110.249 19.4758 110.249 12.5617C110.249 5.61342 115.897 0 122.811 0C129.725 0 135.338 5.61342 135.338 12.5617C135.338 19.4758 129.725 25.055 122.811 25.055ZM162.858 0.924161V25.5L146.189 10.6107V24.8839H141.739V0.308054L158.374 15.7107V0.924161H162.858ZM13.4859 24.8839H8.8651V4.96309H0V0.924161H22.3852V4.96309H13.4859V24.8839ZM33.6805 24.8839H29.094V0.924161H42.5114C47.3376 0.924161 51.2054 4.92886 51.2054 9.89195C51.2054 13.2463 49.4597 16.3268 46.9611 17.6275L50.6919 24.8839H45.5235L42.2718 18.5174H33.6805V24.8839ZM61.1315 24.8839H55.8946L68.0456 0.924161H73.3168L61.1315 24.8839ZM98.2349 24.8839H93.6483V4.96309H84.749V0.924161H107.134V4.96309H98.2349V24.8839ZM122.811 20.6738C127.26 20.6738 130.923 17.0114 130.923 12.5617C130.923 8.04362 127.26 4.38121 122.811 4.38121C118.327 4.38121 114.699 8.04362 114.699 12.5617C114.699 17.0114 118.327 20.6738 122.811 20.6738ZM33.6805 4.96309V14.5812H41.4161C45.2497 14.5812 46.653 11.843 46.653 9.78926C46.653 7.46175 44.7362 4.96309 41.4161 4.96309H33.6805ZM84.1671 24.8839H78.7933L73.796 15.0262L76.4315 9.75503L84.1671 24.8839Z"
      />
    </svg>
  );
};
